export default {
  GET_ALL_ACTIONS: 'getAllActions',
  SAVE_ACTION: 'saveAction',
  UPDATE_ACTION: 'updateAction',
  DELETE_ACTION: 'deleteAction'
}
